module.exports = __webpack_public_path__ + "img/ceo_caption2.b2ee1a17.jpg";